module.exports = __webpack_public_path__ + "img/9.c518f50a.png";